import {getRequest, URL_SERVER} from './../requests'


export async function getProducts(token){
    try {
        return await getRequest(URL_SERVER + '/products', token)
    } catch (error) {
        console.error(error);
    }
}